import React from 'react';
import { useHawkSearch } from 'components/StoreProvider';
import ToolRow from 'components/ui/Results/ToolRow';
import ResultListing from 'components/ui/Results/ResultListing';
import ResultItem, { ResultItemProps } from 'components/ui/Results/ResultItem';
import SearchResultsLabel from 'components/ui/Facets/SearchResultsLabel';
import NoResults from './NoResults';
import CompareItemsBar from 'components/compare-items/CompareItemsBar';
import classnames from 'classnames';
import { ScrollToResults } from 'features/search/FacetsAndResults';

export interface ResultsProps {
	resultItem?: React.ComponentType<ResultItemProps>;
}

function Results({ resultItem = ResultItem, scrollToResults }: ResultsProps & ScrollToResults) {
	const {
		store: { isLoading, searchResults, requestError, itemsToCompare },
	} = useHawkSearch();

	if (requestError) {
		return <span>An error occurred while searching for your results. Please contact the site administrator.</span>;
	}

	// end of overrides
	if ((!searchResults || searchResults.Results.length === 0) && !isLoading) {
		return <NoResults />;
	}

	return (
		<div
			className={classnames('hawk-results', {
				'hawk-results--loading': isLoading,
			})}
		>
			{/*#region : TapeCase*/}
			{searchResults?.Name && <h2>{searchResults.Name}</h2>}

			{searchResults?.CustomHtml && (
				<div
					className="hawk-results-description"
					dangerouslySetInnerHTML={{ __html: searchResults?.CustomHtml }}
				/>
			)}
			{/*#endregion*/}

			<SearchResultsLabel />

			<div className="hawk-results__top-tool-row">
				<ToolRow scrollToResults={scrollToResults} />
			</div>

			{itemsToCompare && itemsToCompare.length > 0 && <CompareItemsBar />}

			<ResultListing resultItem={resultItem} />

			{/*#region : TapeCase*/}
			{itemsToCompare && itemsToCompare.length > 0 && <CompareItemsBar position="bottom" />}
			{/*#endregion*/}

			<div className="hawk-results__bottom-tool-row">
				<ToolRow scrollToResults={scrollToResults} />
			</div>
		</div>
	);
}

export default Results;
